import React, { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useOutletContext } from "react-router";
import Button from "../../../components/Common/Button/Button";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import Dropdown from "../../../components/Common/ReactForm/Dropdown/Dropdown";
import Input from "../../../components/Common/ReactForm/Input/Input";
import {
  getClassNameActionHandler,
  getClassWiseUsageDeatilsActionHandler,
  GetMobileAppInstallationCountActionHandler,
  getMobileInstallationCountActionHanlder,
  getMobileInstallationTrendActionHanlder,
  getNoOfUserAccessedShotclassApplicationActionHandler,
  getNoOfUserAccessedShotclassesActionHandler,
  getShotclassCompletionTrendActionHandler,
  getTotalActiveUserActionHandler,
  getUserGroupAccessDetailsActionHandler,
  getUserGroupActionhandler,
  getUserGroupClassUsageDetailsActionHandler,
} from "../../../store/actions/actionHandlers/reportActionHandler";
import moment from "moment";
import { adoptionReport } from "../../../utils/mainTabs/reports/adoptionReport";
import { setErrorAction } from "../../../store/actions/actionCreators/errorActionCreator";
import { errorTypes } from "../../../utils/errorTypes";
import ReportGraphFilterLayout from "../ReportGraphFilterLayout/ReportGraphFilterLayout";
import classes from "./AdoptionReportPage.module.scss";
import { FormattedMessage, injectIntl } from "react-intl";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputHookForm from "../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import { differenceInDays } from "date-fns";

export const adoptionReportSchema = yup.object().shape({
  ClassName: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .max(15, "Maximum 15 Classes are allowed"),
  userGroup: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .max(15, "Maximum 15 User Groups are allowed"),
});

const AdoptionReportPage = ({ userGroupData, intl }) => {
  const navigate = useNavigate();
  const reportState = useSelector((state) => state.reportReducer);
  const dispatch = useDispatch();
  const { navLinks, tiles, graphs, inputField } = adoptionReport;
  const pageNumber = 1;
  const pageSize = 20;
  const {
    userGroup,
    className,
    totalActiveUsers,
    mobileInstallationCount,
    userGroupAccessDetails,
    userGroupClassUsageDetails,
    classWiseUsageDetails,
    shotclassCompletionTrend,
    noOfUserAccessedShotclassApplication,
    noOfUserAccessedShotclasses,
    mobileAppInstallationCount,
  } = reportState;
  const { SUCCESS, FAIL, WARN } = errorTypes;
  const [fromDate, setFromDate] = useState(0);
  const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState([]);
  const [toDate, setToDate] = useState(0);
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [formData, setFormData] = useState([]);
  const [userGroupOptions, setUserGroupOptions] = useState("none");
  const [classNameOptions, setClassNameOptions] = useState("none");
  const [selectedUserGroupId, setSelectedUserGroupId] = useState("none");
  const [selectedClassId, setSelectedClassId] = useState("none");
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (userGroup.length == 0 || className.length == 0) {
      dispatch(getUserGroupActionhandler());
      dispatch(getClassNameActionHandler());
    }

    if (selectedClassName?.length > 0) {
      const classValue = [];
      selectedClassName?.map((e) => classValue.push(e.value));
      setSelectedClassId(classValue);
    }
    // if (selectedUserGroup?.length > 0) {
    //   const groupValue = [];
    //   selectedUserGroup?.map((opt) => groupValue.push(opt.value));
    //   setSelectedUserGroupId(groupValue);
    // }
  }, [dispatch, selectedClassName]); //selectedUserGroup

  const onFromDateChange = (date) => {
    // setFromDate(new Date(date.target.value).toLocaleDateString());
    setFromDateValue(date.target.value);
    const newDate = moment(date.target.value).format("YYYY-MM-DD");
    setFromDate(newDate);
  };

  const onToDateChange = (date) => {
    setToDateValue(date.target.value);
    const newDate = moment(date.target.value).format("YYYY-MM-DD");
    setToDate(newDate);
  };
  useEffect(() => {
    const userGroupOption = userGroup?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const classNameOption = className?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));

    setUserGroupOptions(userGroupOption);
    setClassNameOptions(classNameOption);
  }, [userGroup, className]);

  const onUserGroupSelected = (selected) => {
    setSelectedUserGroup(selected);
  };

  const onClassNameSelected = (selected) => {
    setSelectedClassName(selected);
  };
  const handleReset = () => {
    setSelectedClassName([]);
    setSelectedUserGroup([]);
    setFromDateValue("");
    setToDateValue("");
    setFromDate(moment().format("dd-mm-yyyy"));
    setIsClicked(false);
    reset();
    setUpdatedClassGroups(className);
    setUpdatedUserGroups(userGroup);
    setFromDate(0);
    setToDate(0);
  };

  const appAdoptionPercentage = Math.ceil(
    (mobileAppInstallationCount / totalActiveUsers) * 100
  );
  const appAccessPercentage = Math.ceil(
    (noOfUserAccessedShotclassApplication / totalActiveUsers) * 100
  );

  const classAttemptPercentage = Math.ceil(
    (noOfUserAccessedShotclasses / totalActiveUsers) * 100
  );

  let adoptionReportTiles = tiles(
    navigate,
    totalActiveUsers,
    noOfUserAccessedShotclassApplication,
    mobileAppInstallationCount,
    noOfUserAccessedShotclasses,
    appAccessPercentage,
    appAdoptionPercentage,
    classAttemptPercentage
  );
  const dateDiff = (start, end) => {
    var a = moment(start, "MM/DD/YYYY");
    var b = moment(end, "MM/DD/YYYY");
    return b.diff(a, "days");
  };
  const onFilterSearch = () => {
    const adbc = moment(fromDate).diff(toDate, "days");
    if (
      selectedUserGroup.length > 0 &&
      fromDate &&
      toDate &&
      fromDate !== "Invalid date" &&
      toDate !== "Invalid date"
    ) {
      const diff = differenceInDays(fromDate, toDate);
      const dateDiffChecker = Math.abs(diff);
      const abc = dateDiff(fromDate, toDate);
      if (dateDiffChecker > 90) {
        dispatch(
          setErrorAction("WARN", "Can select maximum duration of 90 days only")
        );
      } else {
        setIsClicked(true);
        dispatch(
          getTotalActiveUserActionHandler(fromDate, toDate, selectedUserGroupId)
        );
        dispatch(
          getMobileInstallationTrendActionHanlder(
            selectedClassId,
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          getUserGroupClassUsageDetailsActionHandler(
            selectedClassId,
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          getUserGroupAccessDetailsActionHandler(
            selectedClassId,
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          getClassWiseUsageDeatilsActionHandler(
            selectedClassId,
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          getShotclassCompletionTrendActionHandler(
            selectedClassId,
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          getNoOfUserAccessedShotclassApplicationActionHandler(
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          getNoOfUserAccessedShotclassesActionHandler(
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
        dispatch(
          GetMobileAppInstallationCountActionHandler(
            fromDate,
            toDate,
            selectedUserGroupId
          )
        );
      }
    } else {
      dispatch(
        setErrorAction("WARN", "Please select all the (*) required fields")
      );
    }
  };

  const shotclassCompletionTrendData = {
    labels: shotclassCompletionTrend?.map((el) => el.Date),
    datasets: [
      {
        data: shotclassCompletionTrend?.map((el) => el.UserCount),
        backgroundColor: "#2c92de",
      },
    ],
  };

  const mobileAppInstallationTrendData = {
    labels: mobileInstallationCount?.map((e) => e.Date),
    datasets: [
      {
        data: mobileInstallationCount?.map((e) => e.UserCount),
        backgroundColor: "#2c92de",
      },
    ],
  };

  const classWiseUsageDetailsData = {
    labels: classWiseUsageDetails?.map((el) => el.ClassName),
    datasets: [
      {
        label: "Completed",
        data: classWiseUsageDetails?.map((el) => el.CompletedClassesCount),
        backgroundColor: "#5DDEA7",
      },
      {
        label: "In-Progress",
        data: classWiseUsageDetails?.map((el) => el.InProgressClassesCount),
        backgroundColor: "#F5D689",
      },
      {
        label: "Assigned",
        data: classWiseUsageDetails?.map((el) => el.AssignedClassesCount),
        backgroundColor: "#7CA9E3",
      },
      {
        label: "Recalled",
        data: classWiseUsageDetails?.map((el) => el.ArchivedClassesCount),
        backgroundColor: "#B3B3B3",
      },
    ],
  };

  const userGroupClassUsageDetailsData = {
    labels: userGroupClassUsageDetails?.map((el) => el.GroupName),
    datasets: [
      {
        label: "Completed",
        data: userGroupClassUsageDetails?.map((el) => el.CompletedClassesCount),
        backgroundColor: "#5DDEA7",
      },
      {
        label: "In-Progress",
        data: userGroupClassUsageDetails?.map(
          (el) => el.InProgressClassesCount
        ),
        backgroundColor: "#F5D689",
      },
      {
        label: "Assigned",
        data: userGroupClassUsageDetails?.map((el) => el.AssignedClassesCount),
        backgroundColor: "#7CA9E3",
      },
      {
        label: "Recalled",
        data: userGroupClassUsageDetails?.map((el) => el.ArchivedClassesCount),
        backgroundColor: "#B3B3B3",
      },
    ],
  };

  const userGroupAccessDetailsData = {
    labels: userGroupAccessDetails?.map((el) => el.GroupName),
    datasets: [
      {
        label: "Not Accessed",
        data: userGroupAccessDetails?.map((el) => el.NotAssignedClassesCount),
        backgroundColor: "#F5D689",
      },
      {
        label: "Accessed",
        data: userGroupAccessDetails?.map((el) => el.AssignedClassesCount),
        backgroundColor: "#5DDEA7",
      },
    ],
  };

  let graphData = graphs(
    mobileAppInstallationTrendData,
    shotclassCompletionTrendData,
    classWiseUsageDetailsData,
    userGroupClassUsageDetailsData,
    userGroupAccessDetailsData
  );

  useEffect(() => {
    let formArgs = {
      onFromDateChange,
      onToDateChange,
      onUserGroupSelected,
      onClassNameSelected,
      handleReset,
      onFilterSearch,
      handleReset,

      userGroupOptions,
      classNameOptions,
      selectedUserGroup,
      selectedClassName,
      fromDate,
    };

    let data = inputField(formArgs);
    setFormData(data);
  }, [
    userGroupOptions,
    classNameOptions,
    selectedUserGroup,
    selectedClassName,
    fromDate,
  ]);

  const { tenantName } = useOutletContext();

  //mukesh changes

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(adoptionReportSchema),
  });
  const {
    formState: { errors },
    reset,
    watch,
  } = methods;
  //usergroup
  const [userGroupList, setUserGroupList] = useState([]);
  let setUpdatedUserGroups = useCallback(
    (userGroup) => {
      if (userGroup?.length > 0) {
        let updatedUserGroup = userGroup.map((classes) => {
          return { ...classes, isVisible: true };
        });
        setUserGroupList(updatedUserGroup);
        // setSelectedUserGroup(userGroup);
      }
    },
    [userGroup, userGroupList]
  );
  useEffect(() => {
    setUpdatedUserGroups(userGroup);
  }, [dispatch, userGroup]);

  useEffect(() => {
    if (userGroupList.length > 0) {
      const filtered = userGroupList.filter((item) => {
        return item.checked === true;
      });
      if (filtered.length > 0) {
        // setBooleanSelectUser(true);
        let updateFilteredResult = filtered.map((item) => {
          return { label: item.Name, value: item.TypeId };
        });
        setSelectedUserGroup(updateFilteredResult);
        // setSelectedUserGroupId(updateFilteredResult[0]?.label);
      } else {
        setSelectedUserGroup([]);
      }
    }
  }, [userGroupList, setSelectedUserGroup]);
  useEffect(() => {
    if (selectedUserGroup?.length > 0) {
      const groupValue = [];
      selectedUserGroup?.map((e) => groupValue.push(e.value));
      setSelectedUserGroupId(groupValue);
    }
  }, [selectedUserGroup, userGroup, setSelectedUserGroupId]);

  //classes
  const [userClassList, setUserClassList] = useState([]);
  let setUpdatedClassGroups = useCallback(
    (className) => {
      if (className?.length > 0) {
        let updatedUserGroup = className.map((classes) => {
          return { ...classes, isVisible: true };
        });
        setUserClassList(updatedUserGroup);
      }
    },
    [className]
  );
  useEffect(() => {
    setUpdatedClassGroups(className);
  }, [className?.length]);

  useEffect(() => {
    if (userClassList.length > 0) {
      const filtered = userClassList.filter((item) => {
        return item.checked === true;
      });
      let updateFilteredResult = filtered.map((item) => {
        return { label: item.Name, value: item.TypeId };
      });
      setSelectedClassName(updateFilteredResult);
    }
  }, [userClassList, setSelectedClassName]);
  const watchclasses = watch("ClassName");
  const watchGroup = watch("userGroup");
  return (
    <>
      <MainLayout navLinks={navLinks(navigate, tenantName)}>
        {/* <ReportGraphFilterLayout inputField={formData} /> */}

        <div className={classes.reportFilter_Main}>
          <div className={classes.reportFilter_userCLass}>
            <Input
              label={"From Date"}
              type={"date"}
              isFromDate
              isRequired
              value={fromDateValue}
              onChange={onFromDateChange}
            />
            <Input
              label={"To Date"}
              type={"date"}
              min={fromDate}
              isRequired
              isLimit
              maxSelected={"90"}
              validationLabel="Days"
              value={toDateValue}
              onChange={onToDateChange}
            />
            {/* <Dropdown
              isMulti
              // isRequired
              type="multiSelect"
              isRequired
              name={"userGroup"}
              label={<FormattedMessage id="Report_User_Groups" />}
              isLimit
              defaultValue={selectedUserGroup}
              placeholder={intl.formatMessage({
                id: `SELECT_USER_GROUP`,
              })}
              options={userGroupOptions}
              onChange={onUserGroupSelected}
              maxSelected={15}
              validationLabel="Groups"
              selectedValue={selectedUserGroup}
            />

            <Dropdown
              isMulti
              isRequired
              name={"className"}
              label={<FormattedMessage id="SELECT_CLASSES" />}
              isLimit
              defaultValue={selectedClassName}
              placeholder="Select Shotclasses"
              options={classNameOptions}
              onChange={onClassNameSelected}
              maxSelected={15}
              validationLabel="Classes"
              selectedValue={selectedClassName}
            /> */}
            <FormProvider {...methods}>
              <InputHookForm
                label={<FormattedMessage id="Report_UserGroups" />}
                name="userGroup"
                // labelColor="light"
                type="noSearchTags"
                fieldName={"Name"}
                fieldValue="TypeId"
                placeholder={intl.formatMessage({
                  id: `SELECT_USER_GROUP`,
                })}
                labelMsg="(Max: 15 Groups)"
                height="3.9"
                width="25"
                required
                labelColor={"#404040"}
                searchable={true}
                id={"TypeId"}
                searchTagsList={userGroupList}
                handleTagList={(tagsList) => {
                  setUserGroupList(tagsList);
                }}
                //disabled={selectedUser ? true : false}
                error={errors?.userGroup?.message}
              />
              <InputHookForm
                label={<FormattedMessage id="REPORT_CLASSNAME_TXT" />}
                name="ClassName"
                // labelColor="light"
                type="noSearchTags"
                fieldName={"Name"}
                fieldValue="TypeId"
                placeholder={intl.formatMessage({
                  id: `SELECT_CLASSES`,
                })}
                labelMsg="(Max: 15 Classes)"
                height="3.9"
                width="24.5"
                labelColor={"#404040"}
                searchable={true}
                id={"TypeId"}
                searchTagsList={userClassList}
                handleTagList={(tagsList) => {
                  setUserClassList(tagsList);
                }}
                error={errors?.ClassName?.message}
              />
            </FormProvider>
          </div>
          <div className={classes.searchResetButton}>
            <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "12px",
              }}
              onClick={handleReset}
            >
              <FormattedMessage id="RESET_MSG" />
            </span>
            <Button
              label={<FormattedMessage id="SEARCH" />}
              dark
              small
              className={classes.searchButton}
              onClick={onFilterSearch}
              disabled={
                watchclasses?.length > 15 || watchGroup?.length > 15
                  ? true
                  : false
              }
            />
          </div>
        </div>
      </MainLayout>
      {isClicked && (
        <>
          <MainLayout tiles={adoptionReportTiles}>
            <ReportGraphFilterLayout graphs={graphData} />
          </MainLayout>
        </>
      )}
    </>
  );
};

export default injectIntl(AdoptionReportPage);
